(function () {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('parameters.emploie-temps', {
                parent: 'entity',
                url: '/emploie-temps',
                data: {
                    authorities: ['ROLE_RESPONSABLE_INSCRIPTION','ROLE_RESPONSABLE','ROLE_ADMIN'],
                    pageTitle: 'josdaviApp.emploieTemps.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/emploie-temps/emploie-temps.html',
                        controller: 'EmploieTempsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('emploieTemps');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });    }

})();
